<template>
    <div class="relative w-full h-[360px]">
      <!-- Largest chart on the outermost layer -->
      <CanvasJSChart :options="optionsLarge" :styles="styleOptionLarge" />
      <!-- Medium chart in the middle layer -->
      <CanvasJSChart :options="optionsMedium" :styles="styleOptionMedium" />
      <!-- Smallest chart in the center -->
      <CanvasJSChart :options="optionsSmall" :styles="styleOptionSmall" />
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // Large outer chart
        optionsLarge: {
          backgroundColor: null,
          theme: "light2",
          animationEnabled: true,
          data: [{
            type: "doughnut",
            startAngle: 220,
            dataPoints: [
              { label: "", y: 100, color: "#F9F5FF" },
              { label: "", y: 650, color: "#222222" }
            ],
            innerRadius: "85%", // Outer chart's inner radius
            radius: "80%"  // Outer chart's outer radius
          }]
        },
        // Medium middle chart
        optionsMedium: {
          backgroundColor: null,
          theme: "light2",
          animationEnabled: true,
          data: [{
            type: "doughnut",
            startAngle: 190,
            dataPoints: [
              { label: "", y: 180, color: "#F9F5FF" },
              { label: "", y: 650, color: "#F9B848" }
            ],
            innerRadius: "85%", // Middle chart's inner radius, smaller to create gap
            radius: "75%"       // Middle chart's outer radius, smaller to create gap
          }]
        },
        // Small inner chart
        optionsSmall: {
          backgroundColor: null,
          theme: "light2",
          animationEnabled: true,
          data: [{
            type: "doughnut",
            startAngle: 160,
            dataPoints: [
              { label: "", y: 280, color: "#F9F5FF" },
              { label: "", y: 650, color: "#E2DDED" }
            ],
            innerRadius: "80%", // Smallest chart's inner radius
            radius: "70%"       // Smallest chart's outer radius
          }]
        },
        // Style options to control the size and positioning of each chart
        styleOptionLarge: {
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "350px", // Set fixed size for outer chart
          height: "350px",
          transform: "translate(-50%, -50%)",
          background: "none"
        },
        styleOptionMedium: {
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "304px", // Set fixed size for middle chart
          height: "304px",
          transform: "translate(-50%, -50%)",
          background: "none"
        },
        styleOptionSmall: {
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "260px", // Set fixed size for inner chart
          height: "260px",
          transform: "translate(-50%, -50%)",
          background: "none"
        }
      };
    }
  };
  </script>
  
  <style>
  .canvasjs-chart-credit {
    display: none !important;
  }
  /* .canvasjs-chart-toolbar {
    display: none !important;
  } */
  </style>
  